import React, { useEffect, useState } from 'react';
import { Container, Box, Grid, Typography, Button, Card, Pagination } from "@mui/material";
import { BsJustifyLeft } from 'react-icons/bs';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import toast from 'react-hot-toast';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import LeadService from '../../core/services/leadsService';
import LinearProgress from '@mui/material/LinearProgress';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ScrollAnimation from 'react-animate-on-scroll';
const staticMapBaseURL = 'https://maps.googleapis.com/maps/api/staticmap';
// Origin1 agent?assignTo   || origin2 customer 
const MapComponent = ({ origin1, origin2, destination, index }) => {
    let mapURL = `${staticMapBaseURL}?size=250x200&maptype=roadmap`;

    const isValidCoordinate = (coord) => coord !== null && coord !== undefined && !isNaN(coord);

    if (origin1 && isValidCoordinate(origin1?.latitude) && isValidCoordinate(origin1?.longitude)) {
        mapURL += `&markers=color:blue%7Clabel:A%7C${origin1?.latitude},${origin1?.longitude}`;
    }
    if (origin2 && isValidCoordinate(origin2?.latitude) && isValidCoordinate(origin2?.longitude)) {
        mapURL += `&markers=color:green%7Clabel:C%7C${origin2?.latitude},${origin2?.longitude}`;
    }
    if (destination && isValidCoordinate(destination?.latitude) && isValidCoordinate(destination?.longitude)) {
        mapURL += `&markers=color:red%7Clabel:D%7C${destination?.latitude},${destination?.longitude}`;
    }

    mapURL += `&key=AIzaSyC9saN_UXZFij-RjWWX9drQEQSZw5PaPcA`;

    return (
        <div
            style={{
                width: '250px',
                height: '200px',
                borderRadius: '22px',
                boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                marginBottom: '20px',
                marginTop: '15px',

            }}

        >
            <img src={mapURL} alt={`Map ${index}`} style={{ width: '100%', height: '100%', borderRadius: '22px' }} />
        </div>
    );
};
const ViewAllJobRoutes = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [jobRoutes, setJobRoutes] = useState([]);
    const { UserType, selectedValueHoursRoutes, isDateFormate, selectedCityRoutes } = location.state || [];
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPages, setTotalPages] = React.useState(0);
    const [isLoadingDetails, setIsLoadingDetails] = React.useState(false);
    const [getUserType, setGetUserType] = useState(UserType);

    const HandleBackNavigate = () => {
        if (getUserType === 'lead') {
            localStorage.removeItem('selectedValueHoursRoutes');
            localStorage.removeItem('isDateFormate');
            localStorage.removeItem('selectedCityRoutes');
            localStorage.removeItem('UserType');
            navigate('/admin-Leads');
        }
    };

    const getAllJobRoutes = async (hours, dateTime, city, currentPage) => {
        try {
            setIsLoadingDetails(true);
            const res = await LeadService.getAllJobRoutes(hours, dateTime, city, currentPage);
            if (res?.data?.success) {
                setJobRoutes(res?.data?.jobRoutes?.data);
                setCurrentPage(res?.data?.jobRoutes?.current_page || 1);
                setTotalPages(Math.ceil((res?.data?.jobRoutes?.total || 1) / (res?.data?.jobRoutes?.per_page || 1)));
                toast.success(res?.data?.message)
                return;
            }
        } catch (error) {
            toast.success(error?.message)
            console.error(error);
        } finally {
            setIsLoadingDetails(false);
        }
    };

    useEffect(() => {

        // Save values to localStorage if they exist in location.state
        if (selectedValueHoursRoutes) localStorage.setItem('selectedValueHoursRoutes', selectedValueHoursRoutes);
        if (isDateFormate) localStorage.setItem('isDateFormate', isDateFormate);
        if (selectedCityRoutes) localStorage.setItem('selectedCityRoutes', selectedCityRoutes);
        if (UserType) localStorage.setItem('UserType', UserType);

        // Retrieve stored values from localStorage
        const storedSelectedValueHoursRoutes = localStorage.getItem('selectedValueHoursRoutes');
        const storedIsDateFormate = localStorage.getItem('isDateFormate');
        const storedSelectedCityRoutes = localStorage.getItem('selectedCityRoutes');
        const storedUserType = localStorage.getItem('UserType');
        setGetUserType(storedUserType)
        // Fetch job routes using stored or current state values
        getAllJobRoutes(storedSelectedValueHoursRoutes, storedIsDateFormate, storedSelectedCityRoutes, currentPage);
    }, [currentPage]);
    const handleNavigateJobDetailsPage = (id) => {

        const RouteType = 'allJobRoutes'
        navigate(`/admin-leads-details/${id}`, { state: { RouteType: RouteType } });

    };
    return (
        <>
            <div style={{ marginBottom: '15px' }}> {isLoadingDetails && <LinearProgress />}</div>
            <Box>
                <Button onClick={HandleBackNavigate}> <ArrowBackIosIcon fontSize={'medium'} style={{ color: '#c6c0c0' }} /></Button>
            </Box>

            {jobRoutes.length === 0 ? (
                <Box style={{ display: 'flex', justifyContent: 'center', gap: '24px', marginTop: '12px' }}>
                    <Typography>
                        <span style={{ fontWeight: 'bold' }}>No data found</span>
                    </Typography>
                </Box>
            ) : (
                <Container>
                    <Card style={{ height: '60px', borderRadius: '10px', }}>
                        <Box style={{ display: 'flex', justifyContent: 'center', gap: '24px', marginTop: '22px' }}>
                            <Box style={{ display: 'flex' }}>
                                <div>
                                    <LocationOnIcon style={{ color: '#8e8ee7' }} />
                                </div>
                                <Typography>
                                    Blue Marker = <span style={{ fontWeight: 'bold' }}>Agent</span>
                                </Typography>
                            </Box>
                            <Box style={{ display: 'flex' }}>
                                <div>
                                    <LocationOnIcon style={{ color: 'green' }} />
                                </div>
                                <Typography>
                                    Green Marker = <span style={{ fontWeight: 'bold' }}>Customer</span>
                                </Typography>
                            </Box>
                            <Box style={{ display: 'flex' }}>
                                <div>
                                    <LocationOnIcon style={{ color: 'red' }} />
                                </div>
                                <Typography>
                                    Red Marker = <span style={{ fontWeight: 'bold' }}>Destination</span>
                                </Typography>
                            </Box>
                        </Box>
                    </Card>
                </Container>
            )}
            <Container>



                <Box style={{ marginTop: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Grid container spacing={3} style={{ marginTop: '6px', justifyContent: 'center' }}>
                        {jobRoutes?.map((route, index) => (
                            <>
                                <ScrollAnimation animateIn='fadeIn'>
                                    <Grid key={route.id} onClick={() => handleNavigateJobDetailsPage(route?.id)}
                                        style={{
                                            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                            background: 'white', cursor: 'pointer',
                                            marginLeft: '25px',
                                            borderRadius: '22px',
                                            transform: 'scale(1)',
                                            transition: 'transform 0.3s ease-in-out',
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                    >
                                        <MapComponent
                                            origin1={{
                                                latitude: parseFloat(route?.accepted_assigned_lead?.assignto?.latitude),
                                                longitude: parseFloat(route?.accepted_assigned_lead?.assignto?.longitude)
                                            }}
                                            origin2={{
                                                latitude: parseFloat(route?.customer?.latitude),
                                                longitude: parseFloat(route?.customer?.longitude)
                                            }}
                                            destination={{
                                                latitude: parseFloat(route?.buyer_latitude),
                                                longitude: parseFloat(route?.buyer_longitude)
                                            }}
                                            index={index}
                                        />
                                    </Grid>
                                </ScrollAnimation>
                            </>

                        ))}

                    </Grid>
                </Box>
                <Box style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '30px', marginRight: '85px' }}>
                    {jobRoutes.length === 0 ? null : (
                        <Pagination
                            count={totalPages}
                            color="primary"
                            page={currentPage}
                            onChange={(event, page) => { setCurrentPage(page) }} />
                    )}
                </Box>
            </Container>
        </>

    );
};

export default ViewAllJobRoutes;
